<template>
  <section class="mc-section">
    <div class="mc-container">
      <div class="mc-section__title mc-section__title--center">
        {{ data.name }}
      </div>
      <div class="mc-section__body">
        <div class="mc-outfit">
          <img loading="lazy" v-for="image in data.images" class="mc-outfit__image" :src="image.src" width="330" height="298" alt="">
          <dl class="mc-outfit__price-list mc-description-list">
            <div v-for="product in data.products" class="mc-description-list__item">
              <dt class="mc-description-list__term">
                <router-link :to="'/detail/'+product.id+'/'">{{ product.name }}</router-link>
              </dt>
              <dd class="mc-description-list__value">
                <div class="mc-price">
                                            <span v-if="product.price_old > product.price" class="mc-price__old">
                                                {{ product.price_old }} ₽
                                            </span>
                  <span class="mc-price__current">
                                                {{ product.price }} ₽
                                            </span>
                </div>
              </dd>
            </div>
          </dl>
          <a v-if="!add" class="mc-outfit__cta-button mc-button simulated-hover" @click="buy">
                                <span class="mc-button__text">
                                    Купить образ
                                </span>
          </a>
            <router-link to="/basket/" v-if="add" class="mc-outfit__cta-button mc-button simulated-hover" >
                                <span class="mc-button__text">
                                    В корзину
                                </span>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'ProductsBlock',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      add: false
    };
  },

  methods: {
    buy() {
      this.$store.dispatch('addToBasket', {collection:this.data.id, quantity: 1});
      this.add = true;
    }
  },
  components: {

  }
}
</script>